import React from 'react';
import PopupModal from "./PopupModal";
import {Trans, useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import {getSession} from "../../services/Session/reducer";
import {connect} from "react-redux";
import {ReactComponent as AlertIco} from "../../../images/icons/alert-error.svg";

interface OwnProps {
    show: boolean;
    onHide: () => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const UnavailableOrderTypeModal = ({show, session, onHide}: Props) => {
    const {t} = useTranslation();

    const handleOnClick = async () => {
        onHide();
    };

    return (
        <PopupModal
            title={
                <div className="text-center">
                    <Trans
                        i18nKey="modules.cart.field.unavailable_order_type.title"
                        values={{
                            orderType: t(`enums.order.type.${session.order_type}`),
                        }}
                        components={{
                            strong: <strong className="text-danger"/>
                        }}
                    />
                </div>
            }
            show={show}
            onHide={onHide}
            withoutCloseButton
            primaryButton={
                <button type="button" className="btn btn-primary w-100" onClick={handleOnClick}>
                    {t("common.action.understand")}
                </button>
            }
            description={t("modules.cart.field.unavailable_order_type.description")}
            headerIcon={<AlertIco/>}
            headerIconClassName="text-danger"
        />
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(UnavailableOrderTypeModal));